export default [
  {
    path: "/request_list/request-list",
    name: "request-list",
    meta: { auth: true, title: "Request-List" },
    component: () => import("../views/request_list/request-list.vue")
  }
]